import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ContentShell from "components/ContentShell";
import BulkUploadPanel from "components/bulkUpload/BulkUploadPanel";
import configData from "config/config.json";
import {
  bulkCreateNotifications,
  downloadNotificationBulkTemplate,
  validateNotificationBulkUpload,
} from "services/notificationService";

const BulkUploadNotifications = () => {
  const navigate = useNavigate();

  return (
    <ContentShell title="Bulk Upload Notifications">
      <Box sx={{ maxWidth: 980, mx: "auto", py: 1 }}>
        <BulkUploadPanel
          entityLabel="notification"
          templateNote={
            <>
              One row per notification, in the same order as the notification editor. Add
              translations in the <b>Title [iso]</b> and <b>Body [iso]</b> columns. Reference an
              image by its <b>Image ID</b> from the Image Repository, or leave it blank for no
              image. Start and End dates are in <b>UTC</b>: the notification turns on at the
              start, off at the end, and is archived after the <b>Content Auto-Archive Time</b>{" "}
              from Configurations (24 hours by default). Dates use the format{" "}
              <b>YYYY-MM-DDTHH:mm:ss</b>.
            </>
          }
          onDownloadTemplate={downloadNotificationBulkTemplate}
          onValidate={validateNotificationBulkUpload}
          onCommit={bulkCreateNotifications}
          onViewList={() => navigate(configData.routes.notifications.notifications)}
        />
      </Box>
    </ContentShell>
  );
};

export default BulkUploadNotifications;
